<template>
  <div class="page-wrapper">
    <!-- <Tabs  v-model="current" :animated="false">
      <TabPane name="1" label="类目库" v-if="p('goodsInfo/goodsInfoList')">
        <c1></c1>
      </TabPane>
      <TabPane name="2" label="物品档案管理" v-if="p('archives/list')">
        <c2></c2>
      </TabPane>
      <TabPane name="3" label="供应商管理" v-if="p('supplier/list')">
        <c3></c3>
      </TabPane>
    </Tabs>-->
    <mult-tab :data="data"></mult-tab>
  </div>
</template>

<script>
import C1 from "@/views/goodsAssets/category/index";
import C2 from "@/views/goodsAssets/goodsFile/fileManagement/index";
import C3 from "@/views/basicData/suppliers/index";
import { mixin } from "../../mixin";
// import MultTab from "../../components/MultTab";

export default {
  name: "property",
  mixins: [mixin],
  data() {
    return {
      data: {
        current: null,
        coms: [
          {
            title: "类目库",
            component: C1,
            p:'goodsInfo/goodsInfoList'
          },
          {
            title: "物品档案管理",
            component: C2,
            p:'archives/list'
          },
          {
            title: "供应商管理",
            component: C3,
            p:'supplier/list'
          }
        ]
      }
    };
  }
};
</script>

<style scoped>
</style>
